export function FormatSavings(val, userSettings) {
  if (val === '-') return val;

  const value = parseInt(val);
  const symbol = userSettings.currency_symbol;
  const fmt = (n) => FormatNumber(n, userSettings, { useGrouping: true });

  if (value < -100000) {
    return `More than -${symbol}${fmt(100000)}`;
  }

  if (value > 100000) {
    return `More than ${symbol}${fmt(100000)}`;
  }

  if (value >= -3000 && value < 3000) {
    return 'Cost Parity';
  }

  // Negative ranges
  if (value < -3000) {
    // Special edge bucket: [-100000, -96000)
    if (value < -96000) {
      return `-${symbol}${fmt(96000)}-${fmt(100000)}`;
    }

    // Regular 3,000 buckets from -96,000 to -3,000
    const upper = Math.ceil(Math.abs(value) / 3000) * 3000;
    const lower = upper - 3000;
    return `-${symbol}${fmt(lower)}-${fmt(upper)}`;
  }

  // Positive ranges
  if (value >= 3000) {
    // Special edge bucket: [96000, 100000]
    const lower = value >= 96000 ? 96000 : Math.floor(value / 3000) * 3000;
    const upper = value >= 96000 ? 100000 : lower + 3000;
    return `${symbol}${fmt(lower)}-${fmt(upper)}`;
  }

  return value;
}

// Format number based on user locale, with options adding commas for thousands and decimal places
export function FormatNumber(value, userSettings, options = {}) { 
  if (value === null || value === undefined) return;

  // Convert string to number if needed
  const numValue = typeof value === 'string' ? parseFloat(value) : value;

  const locale = userSettings?.currency === 'EUR' ? 'de-DE' : 'en-US';
  const useGrouping = options.useGrouping ?? false; 
  const hasExplicitDecimals = options.decimals !== undefined; 
  const hasMinDecimals = options.minDecimals !== undefined;
  const hasMaxDecimals = options.maxDecimals !== undefined;

  if (!useGrouping && !hasExplicitDecimals && !hasMinDecimals && !hasMaxDecimals) { // return value as is
    return numValue.toLocaleString(locale, {
      useGrouping,
      maximumFractionDigits: 20 // set a high max to avoid truncating decimals if they exist, since we aren't explicitly formatting them
    });
  }

  if (hasMinDecimals || hasMaxDecimals) {
    const minDecimals = hasMinDecimals ? options.minDecimals : 0;
    const maxDecimals = hasMaxDecimals ? options.maxDecimals : 20;
    return numValue.toLocaleString(locale, {
      useGrouping,
      minimumFractionDigits: minDecimals,
      maximumFractionDigits: maxDecimals
    });
  }

  const decimals = hasExplicitDecimals 
    ? options.decimals
    : Number.isInteger(numValue)
      ? 0 // if integer, default to no decimal places
      : 2; // if float, default to 2 decimal places

  return numValue.toLocaleString(locale, {
    useGrouping,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}

export function FormatMonetaryValue(value, userSettings) {
  const FormattedValue = FormatNumber(value, userSettings, {useGrouping: true});
  if (value < 0) {
    return `-${userSettings.currency_symbol}${FormattedValue.slice(1)}`;
  } else {
    return `${userSettings.currency_symbol}${FormattedValue}`;
  }
}

export function FormatMaintPer15kKm(value, userSettings) {
  // update to just be string formatting (or combine w/ above)
  if (value === null || value === undefined) return;
  // convert maintenance dollars per km to per 15,000 km
  value = value * 15000
  return FormatNumber(value, userSettings, {useGrouping: true, decimals: 0});
}

export function FormatTemperatureRange(min, max, useCelsius){
  let hasMin = (min !== null) && (min !== undefined);
  let hasMax = (max !== null) && (max !== undefined)
  let formattedMin = hasMin && ((-1 < min && min < 0) ? 0 : min.toFixed(0)); //prevent an edge case where value could be "-0"
  let formattedMax = hasMax && ((-1 < max && max < 0) ? 0 : max.toFixed(0));
  const unit = useCelsius ? '°C' : '°F';

  if (!hasMin && !hasMax) return 'No Data';
  else if (hasMin && hasMax) return `${formattedMin}${unit} - ${formattedMax}${unit}`;
  else if (hasMin) return `${formattedMin}${unit}`;
  else if (hasMax) return `${formattedMax}${unit}`;
  else return 'No Data';
}

export function FormatGhgReductionAmt(value,userSettings) {
  let amt = FormatNumber(value, userSettings, {useGrouping: true, decimals: 0});
  let unitLabel = null;
  // These are values are hard coded right now since this is the only situation where this specific text can occur, but could/should be standardized in the future in user settings / dashboard core.
  if (userSettings.use_kgs) {
    unitLabel = (value === 1) ? "Metric Ton" : "Metric Tons";
  }  else {
    unitLabel = (value === 1) ? "Ton" : "Tons";
  }
  
  return `${amt} ${unitLabel}`;
}

export function FormatGhgReductionPct(value) {
  return `${Math.round(value * 100)}%`;
}

export function FormatDbSettingsMaintPerKm(cand, settings, userSettings,isBev) {
        let repairPer15k = ''
        if(cand.is_ld === false) {
            if(isBev) {
                repairPer15k = settings.ev_repair_per15k_mdhd;
            } else {
                repairPer15k = settings.phev_repair_per15k_mdhd;
            }
        } else {
            if(isBev) {
                repairPer15k = settings.ev_repair_per15k_ld;
            } else {
                repairPer15k = settings.phev_repair_per15k_ld;
            }
        }
        return FormatNumber(repairPer15k, userSettings, {useGrouping: true, decimals: 0});
    }

export function FormatIceCandFuelCost (vclFuelCost, vcl, settings, userSettings) {
        let val;
        if(vclFuelCost) {
            val = vclFuelCost;
        } else {
            if(vcl.is_diesel) {
                val = settings.diesel_cost;
            } else {
                val = settings.gasoline_cost;
            }
        }
        return FormatNumber(val, userSettings, {useGrouping: true});
      }